<template>
  <div class="print">
    <div class="print_logo">
      <img src="@/assets/images/logo_.png" />
      {{ title[type] }}
    </div>
    <div class="print_contain" v-if="data">
      <div class="print_item flex" v-for="(item, index) in column[type]" :key="index">
        <div class="label">{{ item.label }}</div>
        <div class="">
          <template v-if="Array.isArray(transfromData(item.value))">
            <p v-for="(inner_item, i) in transfromData(item.value)" :key="i">
              {{ inner_item }}
              <!-- <span v-if="i + 1 !== transfromData(item.value).length">、</span> -->
            </p>
          </template>
          <template v-else>
            {{ transfromData(item.value) }}
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.print {
  position: relative;
  text-align: left;
  padding: 30px;

  .print_logo {
    border-bottom: 1px solid #ccc;
    padding-bottom: 20px;
  }

  .print_contain {
    margin: 10px 0;
    padding: 5px 20px;

    .label {
      font-weight: bold;
      width: 200px;
    }

    .print_item {
      margin: 8px 0;
    }
  }
}
</style>
<script>
import Options from "@/utils/options";
export default {
  name: "print",
  data() {
    return {
      column: {
        daily: [
          {
            label: "申請日期",
            value: "created_at",
          },
          {
            label: "工程單編號",
            value: "application.form_id",
          },
          {
            label: "施工單編號",
            value: "form_id",
          },
          {
            label: "工程名稱",
            value: "application.name",
          },
          {
            label: "供應商",
            value: "vendor.vendor_chinese",
          },
          {
            label: "作業類別",
            value: "type",
          },
          {
            label: "特殊作業項目",
            value: "op_id[]",
          },
          {
            label: "施工日期",
            value: "date",
          },
          {
            label: "施工開始時間",
            value: "starttime",
          },
          {
            label: "施工結束時間",
            value: "endtime",
          },
          {
            label: "承攬商監工",
            value: "supervisor.name",
          },
          {
            label: "施工人員",
            value: "employees[].name",
          },
          {
            label: "作業區域",
            value: "area_id[]",
          },
        ],
        urgent: [
          {
            label: "申請日期",
            value: "apply_date",
          },
          {
            label: "施工單編號",
            value: "form_id",
          },
          {
            label: "施工原因",
            value: "reason",
          },
          {
            label: "供應商",
            value: "vendor_chinese",
          },
          {
            label: "作業類別",
            value: "type",
          },
          {
            label: "特殊作業項目",
            value: "op_id[]",
          },
          {
            label: "施工日期",
            value: "date",
          },
          {
            label: "承攬商監工",
            value: "supervisor",
          },
          {
            label: "施工人員",
            value: "people",
          },
          {
            label: "作業區域",
            value: "area_id[]",
          },
        ],
        business: [
          {
            label: "申請日期",
            value: "apply_date",
          },
          {
            label: "施工單編號",
            value: "form_id",
          },
          {
            label: "施工原因",
            value: "reason",
          },
          {
            label: "原事業單位",
            value: "vendor_chinese",
          },
          {
            label: "作業類別",
            value: "type",
          },
          {
            label: "施工日期",
            value: "date",
          },
          {
            label: "承攬商監工",
            value: "supervisor",
          },
          {
            label: "施工人員",
            value: "people",
          },
          {
            label: "作業區域",
            value: "area_id[]",
          },
        ],
      },
      title: {
        daily: "施工單內容",
        urgent: "緊急施工單內容",
        business: "施工單內容",
      },
      options: {
        area: [],
        area_key: "location",
        area_value: "id",
        op: [],
        op_value: "op_id",
        op_key: "op_name",
      },
      data: null,
    };
  },
  computed: {
    work_id() {
      return this.$route.query.id;
    },
    type() {
      return this.$route.query.type;
    },
  },
  async created() {
    this.options.area = await Options.getArea();
    this.options.op = await Options.getSpecialOperation();
    this.getWorkData();
  },
  methods: {
    //daily舊版施工單, urgent緊急施工單, business原事業單位施工單
    getWorkData() {
      if (this.type == "daily") {
        this.$http.api.vendor
          .getDailyConstruction("", this.work_id)
          .then((res) => {
            this.data = res.data;
          })
          .then((res) => {
            window.print();
          });
      } else if (this.type == "urgent") {
        this.$http.api.admin.getUrgent("", this.work_id)
          .then((res) => {
            this.data = res.data;
          })
          .then((res) => {
            window.print();
          });
      } else if (this.type === 'business') {
        //原事業單位
        this.$http.api.admin.getBusineseWork('', this.work_id)
          .then((res) => {
            console.log(res.data);
            this.data = res.data;
          })
          .then((res) => {
            window.print();
          });
      }
    },
    transfromData(th) {
      if (th.includes("[]") && th.includes(".")) {
        const innerKey = th.split("[]");
        const lastKey = innerKey[1].split(".")[1];
        return this.data[innerKey[0]].map((el) => {
          return el[lastKey];
        });
      } else if (th.includes(".")) {
        const innerKey = th.split(".");
        return this.data[innerKey[0]][innerKey[1]];
      } else if (th.includes("[]")) {
        const innerKey = th.split("[]")[0];
        let options = [];
        let options_key = null;
        for (let option_key in this.options) {
          if (innerKey.includes(option_key)) {
            options = this.options[option_key];
            options_key = option_key;
          }
        }
        return options
          .filter((el) => {
            return this.data[innerKey].includes(
              el[this.options[`${options_key}_value`]]
            );
          })
          .map((el) => {
            return el[this.options[`${options_key}_key`]];
          });
      } else {
        return this.data[th];
      }
    },
  },
};
</script>
